import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

function Accordion({ heading, body, open, className }) {
  return (
    <div className={cn('medium rx-accordion-item panel', className, open && 'panel-open')}>
      <div className="panel panel-default">
        <div className="panel-heading">
          <div className="accordion-toggle">
            <span>{heading}</span>
          </div>
        </div>
        <div className={cn('panel-collapse collapse', open && 'in')}>
          <div className="panel-body">{body}</div>
        </div>
      </div>
    </div>
  );
}

Accordion.propTypes = {
  heading: PropTypes.node,
  body: PropTypes.node,
  open: PropTypes.bool,
  className: PropTypes.string,
};

export default Accordion;
